import { styled } from "@mui/material";

const StyledCloseIcon = styled("img")(() => ({
  width: "24px",
  height: "24px",
  fontSize: "24px",
}));

export default StyledCloseIcon;
